module.exports = __webpack_public_path__ + "img/product_02.cc62bfd7.png";